module.exports = __webpack_public_path__ + "img/hero-5-alu-guide-bottom.98fe22d0.png";